/**
 * noembed.com - thumbnail and validation for YouTube/Vimeo URLs
 */

const NOEMBED_URL = "https://noembed.com/embed";

export interface NoembedResponse {
  thumbnail_url?: string;
  title?: string;
  url?: string;
  provider_name?: string;
}

export async function getNoembedInfo(videoUrl: string): Promise<NoembedResponse | null> {
  try {
    const res = await fetch(`${NOEMBED_URL}?url=${encodeURIComponent(videoUrl)}`);
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}

/** Check if URL looks like YouTube or Vimeo (no Instagram/Facebook). */
export function isAllowedVideoUrl(url: string): boolean {
  const u = url.trim().toLowerCase();
  if (/instagram\.com|facebook\.com|fb\.com|fbwatch|fb\.watch/i.test(u)) return false;
  return /youtube\.com|youtu\.be|vimeo\.com/i.test(u);
}
